import React from 'react';

import { Block } from '../common/Block.jsx';

function CloseButtonComponent(props) {
    const className = props.className || 'ol__close';
    let style
    if (props.blockConfig) {
        style = {};

        for (let configName in props.blockConfig) {
            Block.mapStyleConfigProps(style, props.blockConfig[configName], (propName, propValue) => {
                switch (propName) {
                    case 'alignment':
                        if (!props.inLayout) {
                            style.display = 'block';
                            style.margin = Block.marginForAlignment(propValue);
                        }
                        break;
                }
            });
        }
    }
    if (props.builder) {
        if (!style) {
            style = {};
        }
        style.pointerEvents = 'none';
        style.position = 'relative';
    }
    return (
        <button className={className} style={style} onClick={props.onClick}>
            <span className="i i-outline-close" />
        </button>
    );
}

export default { Component: CloseButtonComponent };